import { IColumn } from "@fluentui/react";

import { ContractItem } from "../contract.interface";

export function createEnergyColumns(): Array<IColumn> {
  return [
    {
      key: "installationNumber",
      name: "Número de Instalação",
      minWidth: 200,
      maxWidth: 200,
      fieldName: "additionalInfo.energyInstallationNumber",
      isRowHeader: true,
      data: "string",
      onRender: (item: ContractItem) =>
        item.additionalInfo?.energyInstallationNumber || "-"
    },
    {
      key: "operation",
      name: "Operação",
      minWidth: 150,
      maxWidth: 200,
      fieldName: "operation.name",
      isRowHeader: true,
      data: "string",
      isPadded: true,
      isMultiline: true,
      onRender: (item: ContractItem) => item.operation?.name || "-"
    },
    {
      key: "plan",
      name: "Plano de benefícios",
      minWidth: 150,
      fieldName: "offerPrice.offer.plan.name",
      isRowHeader: true,
      data: "string",
      isPadded: true,
      isMultiline: true,
      onRender: (item: ContractItem) =>
        item.offerPrice?.offer?.plan?.name || "-"
    }
  ];
}
